"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HorizontalStepper = void 0;
var lodash_1 = __importDefault(require("lodash"));
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var HorizontalStepperItem_1 = require("./HorizontalStepperItem");
var HorizontalStepperContainer = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-container',
})(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n\tdisplay: flex;\n\tjustify-content: center;\n\t", "\n\t", "\n\tmargin-top: 80px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-top: 10px;\n\t}\n"], ["\n\tdisplay: flex;\n\tjustify-content: center;\n\t", "\n\t", "\n\tmargin-top: 80px;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmargin-top: 10px;\n\t}\n"])), function (props) { return props.align === 'left' && 'justify-content: flex-start'; }, function (props) { return props.align === 'right' && 'justify-content: flex-end'; });
HorizontalStepperContainer.displayName = 'HorizontalStepperContainer';
var HorizontalStepperArrowContainer = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-arrow-container',
    title: '',
})(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding-bottom: 10px;\n\tmargin-left: 15px;\n\tmargin-right: 15px;\n"], ["\n\tdisplay: flex;\n\tflex-direction: row;\n\talign-items: center;\n\tpadding-bottom: 10px;\n\tmargin-left: 15px;\n\tmargin-right: 15px;\n"])));
HorizontalStepperArrowContainer.displayName = 'HorizontalStepperDash';
var HorizontalStepperArrowDash = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-arrow-dash',
})(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n\twidth: 41px;\n\tborder-bottom: 1px solid #aaaaaa;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmin-width: 15px;\n\t\twidth: auto;\n\t\tdisplay: none;\n\t}\n"], ["\n\twidth: 41px;\n\tborder-bottom: 1px solid #aaaaaa;\n\t@media (min-width: 0) and (max-width: 768px) {\n\t\tmin-width: 15px;\n\t\twidth: auto;\n\t\tdisplay: none;\n\t}\n"])));
HorizontalStepperArrowDash.displayName = 'HorizontalStepperArrowDash';
var HorizontalStepperArrow = styled_components_1.default.div.attrs({
    className: 'tws-horizontal-stepper-arrow',
})(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n\twidth: 0;\n\theight: 0;\n\tborder-style: solid;\n\tborder-width: 5px 0 5px 9px;\n\tborder-color: transparent transparent transparent #aaaaaa;\n\tdisplay: block;\n"], ["\n\twidth: 0;\n\theight: 0;\n\tborder-style: solid;\n\tborder-width: 5px 0 5px 9px;\n\tborder-color: transparent transparent transparent #aaaaaa;\n\tdisplay: block;\n"])));
HorizontalStepperArrow.displayName = 'HorizontalStepperArrow';
var HorizontalStepper = /** @class */ (function (_super) {
    __extends(HorizontalStepper, _super);
    function HorizontalStepper() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HorizontalStepper.prototype.render = function () {
        var _a = this.props, activeItemValue = _a.activeItemValue, items = _a.items, rest = __rest(_a, ["activeItemValue", "items"]);
        var orderedItems = items;
        if (orderedItems) {
            orderedItems = lodash_1.default.orderBy(orderedItems, ['sequence'], ['asc']);
        }
        return (React.createElement(HorizontalStepperContainer, __assign({}, rest), orderedItems &&
            orderedItems.map(function (item, index) {
                return (React.createElement(React.Fragment, { key: "horizontal-stepper-".concat(index) },
                    React.createElement(HorizontalStepperItem_1.HorizontalStepperItem, { item: item, active: activeItemValue ? item.value === activeItemValue : false, stepNo: index + 1 }),
                    index < items.length - 1 && (React.createElement(HorizontalStepperArrowContainer, null,
                        React.createElement(HorizontalStepperArrowDash, null),
                        React.createElement(HorizontalStepperArrow, null)))));
            })));
    };
    return HorizontalStepper;
}(React.Component));
exports.HorizontalStepper = HorizontalStepper;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
